import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
export function FitnessClassTimes() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1388">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1389">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1390">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1391">
            Class Times & Schedule
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1392">
            We offer flexible class times throughout the week to fit your busy
            schedule. Find a time that works for you and start your fitness
            journey.
          </p>
        </div>
        <ScheduleTable data-id="element-1393" />
      </div>
    </section>;
}